import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../styles/applyJob.css";

const ApplyJob = () => {
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [jobs, setJobs] = useState([]);

  /* popup state */
  const [popup, setPopup] = useState({
    show: false,
    type: "success", // success | error
    message: "",
  });

  const [form, setForm] = useState({
    jobId: location.state?.jobId || "",
    jobTitle: location.state?.jobTitle || "",
    candidateName: "",
    email: "",
    mobile: "",
    resume: null,
  });

  const [otherPost, setOtherPost] = useState("");

  /* Fetch jobs */
  useEffect(() => {
    if (!form.jobId) {
      fetch("https://uas-2wis.onrender.com/api/jobs")
        .then((res) => res.json())
        .then((data) => Array.isArray(data) && setJobs(data))
        .catch(() => setJobs([]));
    }
  }, [form.jobId]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "resume") {
      setForm({ ...form, resume: files[0] });
      return;
    }

    if (name === "jobId") {
      if (value === "other") {
        setForm({ ...form, jobId: "other", jobTitle: "" });
      } else {
        const selected = jobs.find((j) => j.id.toString() === value);
        setForm({
          ...form,
          jobId: value,
          jobTitle: selected?.title || "",
        });
      }
      return;
    }

    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!form.resume) {
      setPopup({
        show: true,
        type: "error",
        message: "Please upload your resume before submitting the application.",
      });
      return;
    }

    setLoading(true);

    const formData = new FormData();
    Object.entries(form).forEach(([key, val]) => {
      if (val) formData.append(key, val);
    });

    if (form.jobId === "other") {
      formData.set("jobTitle", otherPost);
    }

    try {
      const res = await fetch("https://uas-2wis.onrender.com/api/careers/apply", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.success) {
        setPopup({
          show: true,
          type: "success",
          message:
            "Your application has been submitted successfully. Our HR team will review your profile and contact you if shortlisted.",
        });

        setForm({
          jobId: "",
          jobTitle: "",
          candidateName: "",
          email: "",
          mobile: "",
          resume: null,
        });
        setOtherPost("");
      } else {
        setPopup({
          show: true,
          type: "error",
          message:
            "Submission failed. Please verify your details and try again.",
        });
      }
    } catch {
      setPopup({
        show: true,
        type: "error",
        message:
          "Server error occurred. Please try again after some time.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="apply-job-page">
      {/* HERO */}
      <section className="apply-hero">
        <h1>Apply for Career Opportunity</h1>

      </section>

      {/* FORM */}
      <section className="apply-section">
        <form className="apply-card" onSubmit={handleSubmit}>
          <h2>Candidate Application Form</h2>

          {/* JOB SELECT */}
          {!form.jobId ? (
            <div className="form-group">
              <label>Select Position</label>
              <select name="jobId" onChange={handleChange} required>
                <option value="">-- Select Job Opening --</option>
                {jobs.map((job) => (
                  <option key={job.id} value={job.id}>
                    {job.title}
                  </option>
                ))}
                <option value="other">Other</option>
              </select>
            </div>
          ) : form.jobId !== "other" ? (
            <div className="form-group readonly">
              <label>Position Applied For</label>
              <input value={form.jobTitle} disabled />
            </div>
          ) : null}

          {/*POST */}
          {form.jobId === "other" && (
            <div className="form-group">
              <label>Position / Post Applied For</label>
              <input
                placeholder="Enter post / designation"
                value={otherPost}
                onChange={(e) => setOtherPost(e.target.value)}
                required
              />
            </div>
          )}

          <div className="form-grid">
            <div className="form-group">
              <label>Full Name</label>
              <input
                name="candidateName"
                value={form.candidateName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

<div className="form-group">
  <label>Mobile Number</label>
  <input
    name="mobile"
    type="tel"
    inputMode="numeric"
    placeholder="10-digit mobile number"
    value={form.mobile}
    maxLength="10"
    required
    onChange={(e) => {
      let value = e.target.value.replace(/\D/g, "");

      // mobile numbers 
      if (value.length === 1 && !/[4-9]/.test(value)) {
        value = "";
      }

      setForm({ ...form, mobile: value });
    }}
  />
</div>


            <div className="form-group">
              <label>Upload Resume</label>
              <input
                type="file"
                name="resume"
                accept=".pdf,.doc,.docx"
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <button className="apply-btn" disabled={loading}>
            {loading ? "Submitting Application..." : "Submit Application"}
          </button>
        </form>
      </section>

      {/* POPUP (SUCCESS + ERROR) */}
      {popup.show && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h2>
              {popup.type === "success"
                ? "Application Submitted"
                : "Submission Failed"}
            </h2>
            <p>{popup.message}</p>
            <button
              className="apply-btn"
              onClick={() => setPopup({ ...popup, show: false })}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApplyJob;
